// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookieBanner_wrapper__PO1mt"};